import React from 'react';
import { Checkbox } from 'components/ui/checkbox';
import { isListItemPresent } from 'utils/filter';
import { IFilterConfig, IFilterConfigList } from './types';

interface IProps {
  item: IFilterConfig;
  setSelected: (arg1: string, arg2: boolean) => void;
  setValues: (arg1: string, arg2: string[]) => void;
}

// DOM ids must not contain whitespace, and option names ("ACH Authorized")
// do — an invalid id breaks the <label htmlFor> association so clicking the
// text won't toggle the box. Slug all whitespace and namespace by filter key
// to keep ids valid and unique across sections in the same popover.
const toId = (...parts: string[]) =>
  parts.join('-').toLowerCase().replace(/\s+/g, '-');

const ListFilter = ({ item, setSelected, setValues }: IProps): JSX.Element => {
  const { selected, key, label, data } = item;
  const { values, options } = data as IFilterConfigList;
  const headerId = toId(key, label);

  return (
    <>
      <div className="flex items-center gap-2 px-2 py-1">
        <Checkbox
          id={headerId}
          data-testid="list-checkbox"
          data-cy={`listFilter_${key}`}
          checked={selected}
          onCheckedChange={(checked) => setSelected(key, checked === true)}
        />
        <label htmlFor={headerId} className="body-subtext-regular">
          {label}
        </label>
      </div>
      {selected && (
        <div className="flex flex-col gap-2 bg-gray-blue-3 p-4">
          {options.map((option) => {
            const optionId = toId(key, option.name);
            return (
              <div className="flex items-center gap-2" key={option.name}>
                <Checkbox
                  id={optionId}
                  data-testid={option.name}
                  checked={isListItemPresent(values, option.value)}
                  onCheckedChange={(checked) => {
                    if (checked === true) {
                      setValues(key, values.concat(option.value));
                    } else {
                      const arr = values.filter((v) => {
                        return Array.isArray(option.value)
                          ? !option.value.includes(v)
                          : v !== option.value;
                      });
                      setValues(key, arr);
                    }
                  }}
                />
                <label htmlFor={optionId} className="footnote">
                  {option.name}
                </label>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default ListFilter;
